import { render, staticRenderFns } from "./Glossary.vue?vue&type=template&id=15d96901"
import script from "./Glossary.vue?vue&type=script&lang=js"
export * from "./Glossary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15d96901')) {
      api.createRecord('15d96901', component.options)
    } else {
      api.reload('15d96901', component.options)
    }
    module.hot.accept("./Glossary.vue?vue&type=template&id=15d96901", function () {
      api.rerender('15d96901', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/elements/glossaryvue/assets/frontend/vue/Glossary.vue"
export default component.exports